import { render, staticRenderFns } from "./VinculoContabil.vue?vue&type=template&id=22d63282&"
import script from "./VinculoContabil.vue?vue&type=script&lang=js&"
export * from "./VinculoContabil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports